import moment from "moment";
import { GetMaintenanceTypes } from "../../redux/maintenance/maintenanceTypes"
import "./style.scss"
import { InfoViolet } from "../../assets/images";

type AppProps={
    maintenanceData:GetMaintenanceTypes | undefined;
}

const ScheduledBanner = ({maintenanceData}:AppProps) => {
  return (
    <div className="banner">
        <img src={InfoViolet} alt={"info"}/>
         {(maintenanceData?.start_time && maintenanceData?.end_time ) && <div className="innerText">{`Upcoming maintenance is scheduled on ${ moment(maintenanceData?.start_time).format('DD-MM-YYYY HH:mm:ss')} and Finac will be unavailable till ${moment(maintenanceData?.end_time).format('DD-MM-YYYY HH:mm:ss')} . Be sure to save your work.`}</div>}
      </div>
  )
}

export default ScheduledBanner